import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 10.998a1 1 0 0 1 .707.293l4 4.002a1 1 0 0 1-1.414 1.414L13 14.413V21a1 1 0 1 1-2 0v-6.587l-2.293 2.294a1 1 0 0 1-1.414-1.414l4-4.002a1 1 0 0 1 .707-.293zM9 3c2.935 0 5.5 1.581 6.89 3.933.02.032.041.051.056.06A.071.071 0 0 0 15.96 7H17a6 6 0 0 1 3.601 10.8 1 1 0 0 1-1.201-1.6A4 4 0 0 0 17 9h-1.042c-.788 0-1.439-.457-1.79-1.049A6 6 0 1 0 4.8 15.286a1 1 0 1 1-1.399 1.428A8 8 0 0 1 9 3z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }